// Permanent, non-dismissible sandbox labelling.
//
// The flow says "Pay now", "Place order" and "Payment successful" while taking
// no payment and minting no credits. Shipping that to production — even behind
// the @meta.com gate — without unmissable labelling would be misleading
// financial UX, so this banner appears on every surface that could be read as
// a purchase, and there is deliberately NO dismiss affordance and no
// environment check that could hide it.

import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export default function SandboxNotice({ className = '' }: { className?: string }) {
  const { t } = useTranslation('settings')
  return (
    <div
      role="note"
      data-testid="billing-sandbox-notice"
      className={`flex items-start gap-2.5 rounded-xl border border-amber-400/25 bg-amber-400/10 px-3 py-2.5 ${className}`}
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-300" strokeWidth={2} />
      <p className="text-xs font-medium leading-5 text-amber-100/90">
        <span className="font-semibold">{t('settingsModal.billing.sandboxTitle')}</span>{' '}
        {t('settingsModal.billing.sandboxBody')}
      </p>
    </div>
  )
}
